import { ActivityDescriptor } from "./activityDescriptor";
import ActivityManager from "../core/activityManager";
import Activity from "./activity";

export class AttachedActivityDescriptor implements ActivityDescriptor {
  private _manager: ActivityManager;
  private _state: ActivityDescriptor;
  private _ownerActivityId: string;

  constructor(
    manager: ActivityManager,
    ownerActivityId: string,
    state: ActivityDescriptor) {
    this._manager = manager;
    this._ownerActivityId = ownerActivityId;
    this._state = state;
  }

  public get ownerId() {
    return this._state.ownerId;
  }

  public get windowIds() {
    return this._state.windowIds;
  }

  public get frameColor() {
    return this._state.frameColor;
  }

  public get context() {
    return this._state.context;
  }

  public get tag() {
    return this._state.tag;
  }

  public detach(descriptor?: ActivityDescriptor): Promise<Activity> {

    descriptor = descriptor || {};

    const merged: ActivityDescriptor = {};

    Object.keys(this._state).forEach((prop) => {
      merged[prop] = this._state[prop];
    });

    merged.context = descriptor.context || merged.context;
    merged.frameColor = descriptor.frameColor || merged.frameColor;

    return this._manager.detachActivities(this._ownerActivityId, merged);
  }
}
